'use strict';

angular.module('bgAngularApp')
  .directive('threadFinder', ['badgame', '$location', '$timeout', function(badgame, $location, $timeout) {
    return {
      restrict: 'E',
      link: function(scope, element, attr) {
        scope.selectedThread = '';

        scope.getThreads = function(query) {
          return badgame.findThreads(query).then(function(data) {
            return data;
          });
        };

        scope.threadSelected = function(item, model, label) {
          // Reset the input on selection because it goes to a new page
          scope.selectedThread = '';

          // Doesn't blur without the timeout for some reason
          $timeout(() => {
            document.activeElement.blur();
          }, 50);

          $location.path('/topic/' + model.id + '/msg' + model.lastpostid);
          $location.hash('msg' + model.lastpostid);
        };
      },
      template: require('../../views/templates/thread-finder.html').default
    };
  }]);
